import {FullPageLoader} from '@common/ui/progress/full-page-loader';
import {Trans} from '@common/i18n/trans';
import { ViewResourceLayout } from './view-resource-layout';
import { useEffect, useState } from 'react';
import { MarketRateSideLeft } from './market-rate-side-left';
import { useMarketRateDate } from '@app_modules/requests/use-market-rate-date';
import { MarketRateDate } from './market-rate-date';
import moment, { now } from 'moment-timezone';
import { MarketRateDateDetail } from './market-rate-date-detail';
import { DetailResourceLayout } from './detail-resource-layout';
import { useUserTimezone } from '@common/i18n/use-user-timezone';
import { useAuth } from '@common/auth/use-auth';
import { getCookie } from '@common/utils/hooks/use-cookie';

export function MarketRateViewPage() {
  const query = useMarketRateDate();

  const [dates, setDates] = useState<any>([]);

  const timezone = useUserTimezone();
  useEffect(() => {
    if (query.data && query.data.pagination) {
      let arr_dates = query.data.pagination.data;

      arr_dates.sort((a: any, b: any) => new Date(a.created_date).getTime() - new Date(b.created_date).getTime());

      const currentDate: string = moment.utc().tz(timezone).format('YYYY-MM-DD');
      const dateExists: boolean = arr_dates.some((item: MarketRateDate) => item.created_date === currentDate);
      if (!dateExists) {
        arr_dates.push({ created_date: currentDate });
      }
      setDates(arr_dates);
    }
  }, [query.data]);

  if (query.status !== 'success' || dates.length == 0) {
    return <FullPageLoader />;
  }

  return <PageContent marketRateDates={dates}/>;
}

interface PageContentProps {
  marketRateDates: MarketRateDate[];
}
function PageContent({ marketRateDates}: PageContentProps) {
    
  const [marketRateDate, setMarketRateDate] = useState<any>(null);
  const [timeChange, setTimeChange] = useState<any>(null);
  const [selectDefaultTab, setSelectDefaultTab] = useState(false);

  const changeDate = (date: any, select_tab: string) => {
    setMarketRateDate(date);
    setTimeChange(now());
  };

  const changeDefaultTab = (defaultTab: boolean) => {
    if (defaultTab) {
      setSelectDefaultTab(true);
    }

  };

  const [latestDate, setLatestDate] = useState<any>();
  marketRateDates ? marketRateDates.at(-1) : ''
  const {user} = useAuth();
  const user_id = user?.id;
  const default_market_rate_date = user_id && getCookie('market-rate-date-'+user_id) ? getCookie('market-rate-date-'+user_id) : '';


  useEffect(() => {
    if (marketRateDates.at(-1)) {
      const item = marketRateDates.at(-1);
      setLatestDate(item);
      setMarketRateDate(default_market_rate_date ? default_market_rate_date : item?.created_date);
    }
  }, [marketRateDates]);

  return (
    <DetailResourceLayout
      title={
        <Trans message="Market Rate Analysis"/>
      }
      // isLoading={viewMarketRate.isPending}
    >
      <div className="bg-gray-50 flex ">
        <div className="w-full mx-auto grid grid-cols-12 bg-gray-200">
          <div className="col-span-1 border-b-2 text-center">
            <h3 className='text-bold'><Trans message="Historical Analysis"/></h3>
            <MarketRateSideLeft  changeDefaultTab={changeDefaultTab} marketRateDates={marketRateDates} changeDate={changeDate} latestDate={default_market_rate_date ? default_market_rate_date : latestDate?.created_date}/>
          </div>
          <div className="col-span-11 bg-gray-300">
            <MarketRateDateDetail marketRateDate={marketRateDate} timeChange={timeChange} selectDefaultTab={selectDefaultTab}/>
          </div>
        </div>
      </div>
    </DetailResourceLayout>
  );
  
}
